import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumbers } = CommonParameters;

export const paymentSettingsSetUp: IMcAppType = {
  name: "paymentSettingsSetUp",
  path: "/my/payment-settings/setup",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Setup direct debit for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Set up direct debit",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentSettingsSetUp",
    customerType: CustomerType.kraken,
  },
};
